import { Box, Button, IconButton, useMediaQuery } from "@mui/material";
import { Modal, TextField, Typography } from "@mui/material";
import { styles } from "../../pages/TeamManagement/styles";
import { Dispatch, SetStateAction, useContext, useState } from "react";
import { APP_COLOR, APP_HOVER_COLOR } from "../../theme";
import { TEXT_COLOR } from "../../theme";
import CloseIcon from "@mui/icons-material/Close";
import PersonAddAlt1Icon from "@mui/icons-material/PersonAddAlt1";
import { CustomPaper, SelectField } from "../../pages/MyTracks/styles";
import { useStyles } from "../../pages/MyTracks/styles";
import { addEnterpriseMemberModalStyles } from "./styles";
import useGetValidAccessToken from "../../hooks/useGetValidAccessToken";
import { addMemberToEnterprise } from "../../services/enterpriseService";
import { toast } from "react-toastify";
import { AddMemberToEnterpriseResponse, User } from "../../proto/api_pb";
import { UserDetailsContext } from "../../contexts";
import { CustomCircularProgress } from "../ProgressComponents/CustomCircularProgress";
export interface AddEnterpriseMemberModalProps {
  getTeamMembers: () => Promise<void>;
  teamMembers: User[];
  setTeamMembers: Dispatch<SetStateAction<User[]>>;
}
export const AddEnterpriseMemberModal: React.FC<
  AddEnterpriseMemberModalProps
> = ({ getTeamMembers, teamMembers, setTeamMembers }) => {
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [open, setOpen] = useState(false);
  const [email, setEmail] = useState<string>("");
  const [role, setRole] = useState<string>("");
  const { userName, enterprise } = useContext(UserDetailsContext);
  const { getValidAccessToken } = useGetValidAccessToken();
  const classes = useStyles();
  const isSmallScreen = useMediaQuery("(max-width:600px)");
  const handleOpen = () => setOpen(true);
  const handleClose = () => {
    setOpen(false);
    setIsAllReadyRegistered(false);
  };
  const [isAllReadyRegistered, setIsAllReadyRegistered] = useState(false);

  const handleSubmit = async () => {
    setIsLoading(true);
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(email)) {
      toast.error("Please enter a valid email address");
      setIsLoading(false);
      return;
    }
    const token = await getValidAccessToken();
    const res = await addMemberToEnterprise(
      token,
      email,
      role,
      enterprise?.id ?? "",
      enterprise?.name ?? "",
      userName
    );
    if (res instanceof AddMemberToEnterpriseResponse) {
      toast.info("Member added successfully");
      setTeamMembers([]);
      await getTeamMembers();
      handleClose();
    } else {
      console.log(res);
    }
    setIsLoading(false);
  };

  return (
    <>
      <Button
        style={styles.addMemberButton}
        onClick={handleOpen}
        sx={styles.button}
      >
        <PersonAddAlt1Icon sx={styles.personAddAltIcon} />
        Add Member
      </Button>
      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-mod al-description"
      >
        <Box
          sx={{
            ...addEnterpriseMemberModalStyles.modal,
            width: isSmallScreen ? "100%" : "auto",
          }}
        >
          <Box sx={addEnterpriseMemberModalStyles.addMemberContainer}>
            <Box>
              <Box sx={addEnterpriseMemberModalStyles.addPersonIconContainer}>
                <PersonAddAlt1Icon />
              </Box>
              <Typography
                variant="h6"
                sx={addEnterpriseMemberModalStyles.heading}
              >
                Add Member
              </Typography>
            </Box>
            <IconButton sx={{ height: "40px" }} onClick={handleClose}>
              <CloseIcon />
            </IconButton>
          </Box>
          <Box sx={addEnterpriseMemberModalStyles.detailsContainer}>
            <Box>
              <Typography sx={{ color: TEXT_COLOR }}>Member Email</Typography>
              <TextField
                onChange={(e) => {
                  const isEmailRegistered = teamMembers.some(
                    (member) => member.getEmail() === e.target.value
                  );
                  if (isEmailRegistered) {
                    setIsAllReadyRegistered(true);
                  } else {
                    setIsAllReadyRegistered(false);
                  }
                  setEmail(e.target.value);
                }}
                helperText={isAllReadyRegistered ? "Already registered" : ""}
                sx={{
                  width: "280px",
                  borderRadius: "var(--radius-md, 8px)",
                  "& .MuiOutlinedInput-root": {
                    "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                      borderColor: APP_COLOR,
                      boxShadow:
                        "0px 1px 2px 0px rgba(16, 24, 40, 0.05), 0px 0px 0px 4px rgba(158, 119, 237, 0.24)",
                    },
                  },
                }}
                placeholder="Add Email"
                error={isAllReadyRegistered && email !== ""}
              />
            </Box>
            <Box>
              <Typography sx={{ color: TEXT_COLOR }}>Select Role</Typography>
              <SelectField
                style={{
                  width: "280px",
                }}
                options={["Artist", "Manager", "Admin"]}
                onChange={(_e, value) => {
                  setRole(value as string);
                }}
                defaultValue={"Artist"}
                disableClearable
                renderInput={(params: any) => (
                  <TextField
                    sx={{
                      width: "280px",
                      "& .MuiInputLabel-root": {
                        color: "gray",
                      },
                      "& .MuiInputLabel-root.Mui-focused": {
                        color: "gray",
                      },
                    }}
                    {...params}
                    InputLabelProps={{ shrink: false }}
                    classes={{ root: classes.customTextField }}
                  />
                )}
                PaperComponent={CustomPaper}
              />
            </Box>
          </Box>
          <Box sx={addEnterpriseMemberModalStyles.buttonContainer}>
            <Button
              disabled={isAllReadyRegistered}
              sx={{
                ...styles.button,
                backgroundColor: APP_COLOR,
                "&:hover": {
                  backgroundColor: APP_HOVER_COLOR,
                },
                color: "black",
              }}
              onClick={handleSubmit}
            >
              {isLoading ? (
                <CustomCircularProgress size={22} customcolor="white" />
              ) : (
                "Add"
              )}
            </Button>
            <Button onClick={handleClose} sx={styles.button}>
              Cancel
            </Button>
          </Box>
        </Box>
      </Modal>
    </>
  );
};
